import React, { useState } from 'react'
import styles from "./Styles/Settings.module.css"
import Input from "../../Components/Input"
import navLogo from "../../Assets/navLogo.png"
import { SketchPicker } from 'react-color'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

export default function Settings() {
  const [editable, setEditable] = useState(false)
  return (
    <div className={styles.container}>
        <header>
            <p>System Settings</p>
        </header>

        <h2>Company Details</h2>

        <div className={styles.row}>
        <div>
        <Input labelStyle={{fontSize:14,marginLeft:10}} value="Private Limited Company" label="Name" />
        </div>
        <div>
        <Input labelStyle={{fontSize:14,marginLeft:10}} value="GST1084097184" label="GSTIN" />
        </div>
        <div className={styles.phoneInput}>
        <label>Tel No</label>
        <PhoneInput
            style={{marginTop:14}}
            placeholder=""
            value='+918825014571'
            onChange={(e)=>console.log(e)}
          />
        </div>
        <div>
        <Input white labelStyle={{fontSize:14,marginLeft:10}} value="XYZpvtltd.com" label="Website" />
        </div>
        </div>

        <h2>System Configuration</h2>

        <div className={styles.changes}>
          <div className={styles.change}>
          <h3></h3>
          <h4>YOUR CHANGES</h4>
          </div>

          <div className={styles.change}>
          <h3>Company Logo</h3>
          <div>
            <img src={navLogo} />
          </div>
          </div>

          <div className={styles.change}>
          <h3>Tagline</h3>
          <Input width={320} white />
          </div>

          <div className={styles.change}>
          <h3>Description</h3>
          <Input width={320} white />
          </div>

          {/* <div className={styles.change}>
          <h3>Primary Color</h3>
          <div>

          </div>
          </div> */}
        </div>

        {!editable ? <footer>
          <button onClick={()=>setEditable(true)} className={styles.editBtn}>Edit Details</button>
        </footer> : <footer>
          <button onClick={()=>setEditable(false)} className={styles.cancelBtn}>Cancel</button>
          <button onClick={()=>setEditable(false)} className={styles.saveBtn}>Save Changes</button>
          </footer>}
        
    </div>
  )
}
